export default __webpack_public_path__ + "static/media/ts.17936c69.png";